'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocalTransactionById = exports.getLocalTransactionsToDiscard = exports.getPendingTransactions = undefined;

var _lodash = require('lodash');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get an array of txHashes of all pending transactions in state.
 *
 * @param {Object} state
 *
 * @returns {Array}
 */
var getPendingTransactions = exports.getPendingTransactions = function getPendingTransactions(state) {
  var localTransactions = state.transactions.localTransactions;

  var filterByStatus = function filterByStatus(txHash) {
    return localTransactions[txHash].status === _constants.TransactionStatusEnum.pending;
  };

  return Object.keys(localTransactions).filter(filterByStatus);
};

var getLocalTransactionsToDiscard = exports.getLocalTransactionsToDiscard = function getLocalTransactionsToDiscard(state) {
  var waitTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { minutes: 5 };

  var transactions = state.transactions.localTransactions;
  var discardDate = (0, _moment2.default)().subtract(waitTime).unix();
  return Object.keys(transactions).filter(function (txHash) {
    return transactions[txHash].updated < discardDate;
  });
};

var getLocalTransactionById = exports.getLocalTransactionById = function getLocalTransactionById(state, id, actionType) {
  return (0, _lodash.values)(state.localTransactions).find(function (t) {
    return t.id === id && t.actionType === actionType;
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/selectors/transactions.js
// module id = 1152
// module chunks = 0